import React, { useState, useEffect } from "react";
import axios from "axios";
import { UtmeSubjects, UtmeSubjectNames } from './subjects';
import AuthHeader from "../../../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../../../UI/AuthSideMenu/AuthSideMenu";
import Button from "../../../UI/Buttons/Button";
import { FaLongArrowAltLeft } from "react-icons/fa";
import AuthInput from '../../../UI/Input/AuthInputs';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { ButtonThin, ButtonTransparentSquare, } from "../../../UI/Buttons/Buttons";
import { Modal } from "../../../UI/Modal/Modal";
import ExamReadyModal from "../../ExamReadyModal";
import useExamStartGate from "../../../../hooks/useExamStartGate";
import OvalSpinner from "../../../UI/Spinners/OvalSpinner";
import { GrSend } from "react-icons/gr";
import Rules from "../../Rules";
import { setFetching } from "../../../../redux/states";
import { checkAuthenticatedUser, startExamSession } from "../../../../utils/client-functions";
import { useErrorSetter, useSuccessSetter } from '../../../../hooks/useUiMessages';
import BubbleFloat from "../../../UI/BubbleFloat/BubbleFloat";

const Utme = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [authMenuOpen, setAuthMenuOpen] = useState(false);
    const [chosenSubjectsLoading, setChosenSubjectsLoading] = useState(false);
    const [chosenSubjects, setChosenSubjects] = useState([]);
    // const [subjects, setSubjects] = useState(UtmeSubjects);
    const [subject, setSubject] = useState({});
    const [courseOfStudy, setCourseOfStudy] = useState("");
    const [loading, setLoading] = useState(false);
    const [progressStatus, setProgressStatus] = useState('Gathering Exam Details...');
    const [progressPercentage, setProgressPercentage] = useState(0);
    const { examReady, handleOngoing, handleDoneEvent, confirmStartExam, closeGate } = useExamStartGate(navigate, dispatch);

    const screenWidth = window.innerWidth;
    const isAuth = localStorage?.getItem("token");

    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();
    useEffect(() => {
        const verifyAuth = async () => {
            try {
                await checkAuthenticatedUser();
            } catch (error) {
                if (typeof errorSetter === 'function') errorSetter("Please login to access mock exams");
                sessionStorage.setItem("prevPath", window.location.pathname);
                if (typeof navigate === 'function') navigate("/popin");
            }
        };
        verifyAuth();
    }, [navigate, errorSetter]);


    const checkIfAuth = async () => {
        try {
            await checkAuthenticatedUser();
        } catch (error) {
            dispatch(setFetching(false));
            errorSetter("Please login to generate an exam");
            sessionStorage.setItem("prevPath", window.location.pathname);
            return navigate("/popin");
        }
    };

    const closeModalsAndReset = () => {
        setSubject({});
    };

    const handleGetCourseSubjects = async () => {
        await checkIfAuth();

        if (courseOfStudy.trim() === "") {
            errorSetter("Please enter your course of study");
            return;
        }

        setChosenSubjectsLoading(true);

        const data = {
            courseOfStudy,
            UtmeSubjectNames
        };
        try {
            const response = await axios.post("/mock/get-utme-course-subjects", data, {
                headers: {
                    "x-access-token": isAuth,
                },
            });

            const subjectNames = response.data.answer?.subjectsForCourse || [];
            // Map subject names to full subject objects
            const mappedSubjects = subjectNames
                .map(name => UtmeSubjects.find(obj => obj.subject === name))
                .filter(Boolean);

            setChosenSubjects(mappedSubjects);
            if (response.data.answer?.isValidCourseOfStudy) {
                successSetter("Subjects fetched successfully");
            } else {
                errorSetter("Invalid course of study. Please try again with a valid one.");
            }
        } catch (error) {
            console.error("Error fetching course subjects:", error);
            errorSetter("Failed to fetch course subjects. Please try again.");
        }

        setChosenSubjectsLoading(false);
    };

    const handleKeyDown = (e) => {
        if (screenWidth > 900) {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleGetCourseSubjects();
            }
        }
    };

    const handleCourseOfStudyChange = (e) => {
        if (e.target.value.length > 100) {
            const newValue = e.target.value.slice(0, 100);
            setCourseOfStudy(newValue);
            errorSetter("Course of study must not be more than 100 characters");
            return;
        }
        setCourseOfStudy(e.target.value);
    };

    const toggleAuthMenu = () => {
        setAuthMenuOpen(!authMenuOpen);
    };


    const handleStartExam = async () => {
        await checkIfAuth();
        if (Object.keys(subject).length === 0) {
            errorSetter("Please select a subject to start the exam");
            return;
        }

        setLoading(true);
        setProgressStatus("Gathering Exam Details...");
        setProgressPercentage(5);

        const subjectWithExamName = {
            ...subject,
            examName: "UTME"
        };

        try {
            await startExamSession({
                payload: subjectWithExamName,
                tokenOverride: isAuth,
                onOngoing: (examDetails) => { setLoading(false); handleOngoing(examDetails); },
                onDone: (e) => { handleDoneEvent(e); },
                onError: (msg) => { setLoading(false); errorSetter(msg); },
                setLoading, setProgressStatus, setProgressPercentage
            });
        } catch (error) {
            setLoading(false);
            errorSetter(error?.response?.data?.message || error?.response?.data?.error || "An Error Occurred. Please try again. If issue persist, please chat with us.");
            if (error?.response?.data?.openPricing) {
                window.dispatchEvent(new CustomEvent('openExamPricing'));
            }
        }
    };




    return (
        <div className="auth-container">
            <BubbleFloat/>

            <div className="auth-container-inner content">
                <AuthHeader
                    authMenuOpen={authMenuOpen}
                    onClick={toggleAuthMenu}
                    headerText="UTME MOCK"
                />
                <AuthSideMenu opened={authMenuOpen} arrayDetails={[]} onSwitch={() => {}} />

                <div style={{ margin: '20px 0' }}>
                    <Button secondaryLight={true} link='/user/dashboard/mock'>
                        <FaLongArrowAltLeft size='1rem' color='crimson' /> &nbsp;back to exams
                    </Button>
                </div>

                <div className="BodyWrapper">
                    <div className="BuildNavigator">
                        <div className="ActiveNav">
                            <span>1</span>Selection
                        </div>
                        <div> <span>2</span>Simulation </div>
                        <div> <span>3</span>Insights & Tutor </div>
                    </div>

                    <div style={{ padding: '20px 5px' }}>

                        <div style={{ marginBottom: 16 }}>
                            <h4>Get UTME Subjects</h4>
                            <div style={{ width: screenWidth < 900 ? '100%' : '50%', margin: '20px auto', position: 'relative' }}>
                                <AuthInput
                                    id="courseOfStudy"
                                    name="courseOfStudy"
                                    value={courseOfStudy}
                                    placeholder="Tell me your chosen course to get the right UTME subjects."
                                    inputGridSm={12}
                                    multiline={true}
                                    buttonInInput={true}
                                    rows={2}
                                    maxRows={2}
                                    mt={1}
                                    mb={1}
                                    onKeyDown={handleKeyDown}
                                    onChange={handleCourseOfStudyChange}
                                />
                                <div style={{ position: 'absolute', top: '.5rem', right: '18px', zIndex: 1 }}>
                                    <ButtonTransparentSquare
                                        type="button"
                                        onClick={handleGetCourseSubjects}
                                        color=""
                                        width="35px"
                                        height="35px"
                                        bgColor="black"
                                        borderRadius="50%"
                                    >
                                        {chosenSubjectsLoading ? (
                                            <OvalSpinner size={20} color="#3E8F93" />
                                        ) : (
                                            <GrSend style={{ color: "#3E8F93", fontSize: '1.5em' }} />
                                        )}
                                    </ButtonTransparentSquare>
                                </div>
                            </div>
                        </div>

                        {chosenSubjects.length > 0 && (
                            <div>
                                <h4>Select a Subject to Start</h4>

                                <div style={{ display: 'flex', justifyContent: 'space-around', paddingLeft: 1, paddingBottom: 1, flexWrap: 'wrap', marginTop: '20px' }}>
                                    {chosenSubjects.map((subject, index) => (
                                        <div key={index} style={{ marginBottom: "10px", maxWidth: "12rem", minWidth: "10rem" }}>
                                            <ButtonThin
                                                fontSize='.8rem'
                                                border='1px solid #E5E5EA'
                                                width={'100%'}
                                                height='40px'
                                                color='black'
                                                onClick={() => setSubject(subject)}
                                            >
                                                {subject.subject}
                                            </ButtonThin>
                                        </div>
                                    ))}
                                </div>

                                {chosenSubjects.length === 4 && (
                                    <div style={{ padding: '8px', width: '100%', textAlign: 'right' }}>
                                        <span
                                            onClick={() => setChosenSubjects(UtmeSubjects)}
                                            style={{ color: '#5fbec5', cursor: 'pointer', fontSize: '12px', textDecoration: 'none', fontWeight: 'bold' }}>
                                            View All UTME Subjects →
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

        {Object.keys(subject).length >= 1 && !examReady && (
            <Rules
                examName={"Unified Tertiary Matriculation Exam"}
                closeModalsAndReset={closeModalsAndReset}
                subject={subject}
                handleStartExam={handleStartExam}
            />
        )}

        {loading && (
            <Modal
                header4={`PROCESSING... DO NOT RELOAD`}
                header3={progressStatus}
                progress={progressPercentage}
            />
        )}
        {examReady && (
            <ExamReadyModal
                isOpen={examReady}
                onClose={closeGate}
                onStart={confirmStartExam}
                examLabel="UTME"
            />
        )}
        </div>
    );
};

export default Utme;

